/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import TextField from 'components/DesignSystem/TextField';

export default function TextArea({ rows = 2, ...otherProps }) {
  return <TextField as="textarea" rows={rows} {...otherProps} />;
}
